import React, { useContext } from 'react';
import WidgetOpeningProps from 'modules/shared/widgets/components/widget-opening/widget-opening.props';
import WidgetOpeningSlider from 'modules/shared/widgets/components/widget-opening/components/widget-opening-slider';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import classNames from 'classnames';
import SrcSet from '../../../components/src-set/src-set';
import getLinkRelByTarget from 'helpers/get-link-rel-by-target';

import './widget-opening.scss';

const WidgetOpening: React.FC<WidgetOpeningProps> = ({ config, data }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const isMobile = api.getDevice() === 'mobile';

    return (
        <div
            className={classNames({
                'widget-opening': true,
                'widget-opening-m': isMobile
            })}
        >
            <WidgetOpeningSlider
                autoPlay={config.autoPlay}
                banner={data.banner}
                isMobile={isMobile}
            />
            <div className="widget-opening__boxes">
                {data.boxes.map((item, idx) => (
                    <a
                        className={`item item--${idx + 1}`}
                        key={String(idx)}
                        href={item.url}
                        target={item.target}
                        rel={getLinkRelByTarget(item.target)}
                    >
                        <SrcSet
                            className="widget-opening__boxes__link__image"
                            images={item.modifiedImg}
                            alt={item.alt.trim() || `Obrazek ${idx}`}
                            isMobile={isMobile}
                        />
                    </a>
                ))}
            </div>
        </div>
    );
};

export default WidgetOpening;
